







import { defineComponent } from '@nuxtjs/composition-api';

interface Props extends Blok {

}

export default defineComponent({
  name: 'TypeForm',
  props: {
    blok: {
      type: Object as () => Props,
      required: true,
    },
  },
  head: {
    script: [
      {
        src: '//embed.typeform.com/next/embed.js',
        body: true,
      },
    ],
  },
});
